/**
 * @fileoverview CSS module for the Icon component that handles icon display and positioning.
 * Provides styling for icons with consistent dimensions and positioning.
 *
 * @example
 * // Usage in a component:
 * import styles from './Icon.module.css'
 *
 * function Icon() {
 *   return <img className={styles.icon} src="icon.png" alt="Icon" />
 * }
 */


.icon {
    object-fit: none;
    object-position: 0px 0px;
    width: 32px;
    height: 32px;
}
